module.exports = __webpack_public_path__ + "static/media/graphic.99e2560b.svg";